import React, { useEffect, useState } from 'react'

const THEME_KEY = 'theme'

export default function DarkModeToggle() {
  const [isDark, setIsDark] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return
    const stored = (() => {
      try {
        return localStorage.getItem(THEME_KEY)
      } catch (e) {
        return null
      }
    })()

    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    const initialDark = stored ? stored === 'dark' : prefersDark

    const html = document.documentElement
    if (initialDark) html.classList.add('dark')
    else html.classList.remove('dark')

    setIsDark(initialDark)
  }, [])

  const toggle = () => {
    const html = document.documentElement
    const next = !isDark
    if (next) html.classList.add('dark')
    else html.classList.remove('dark')

    try {
      localStorage.setItem(THEME_KEY, next ? 'dark' : 'light')
    } catch (e) {
      // ignore
    }

    setIsDark(next)
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label="Toggle dark mode"
      aria-pressed={isDark}
      className="flex items-center"
    >
      <span className={`relative inline-flex items-center w-14 h-7 p-1 rounded-full transition-colors duration-300 ${isDark ? 'bg-slate-700' : 'bg-yellow-300'}`}>
        <span className={`absolute left-1 w-4 h-4 flex items-center justify-center text-yellow-500 transition-opacity duration-300 ${isDark ? 'opacity-0' : 'opacity-100'}`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-3 h-3" fill="currentColor">
            <path d="M6.76 4.84l-1.8-1.79L3.17 4.84l1.79 1.8 1.8-1.8zM1 13h3v-2H1v2zm10-9h2V1h-2v3zm7.03 2.05l1.79-1.8-1.79-1.79-1.8 1.79 1.8 1.8zM17.24 19.16l1.8 1.79 1.79-1.79-1.79-1.8-1.8 1.8zM20 11v2h3v-2h-3zM11 23h2v-3h-2v3zM4.22 18.36l1.79-1.8-1.79-1.79-1.8 1.79 1.8 1.8zM12 6a6 6 0 100 12 6 6 0 000-12z" />
          </svg>
        </span>

        <span className={`transform transition-transform duration-300 ease-in-out inline-block w-5 h-5 rounded-full bg-white shadow-md ${isDark ? 'translate-x-7' : 'translate-x-0'}`}>
          <span className="flex items-center justify-center w-full h-full">
            {isDark ? (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-3 h-3 text-slate-700" fill="currentColor">
                <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-3 h-3 text-yellow-500" fill="currentColor">
                <path d="M6.76 4.84l-1.8-1.79L3.17 4.84l1.79 1.8 1.8-1.8zM1 13h3v-2H1v2zm10-9h2V1h-2v3zm7.03 2.05l1.79-1.8-1.79-1.79-1.8 1.79 1.8 1.8zM17.24 19.16l1.8 1.79 1.79-1.79-1.79-1.8-1.8 1.8zM20 11v2h3v-2h-3zM11 23h2v-3h-2v3zM4.22 18.36l1.79-1.8-1.79-1.79-1.8 1.79 1.8 1.8zM12 6a6 6 0 100 12 6 6 0 000-12z" />
              </svg>
            )}
          </span>
        </span>

        <span className={`absolute right-1 w-4 h-4 flex items-center justify-center text-slate-200 transition-opacity duration-300 ${isDark ? 'opacity-100' : 'opacity-0'}`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-3 h-3" fill="currentColor">
            <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
          </svg>
        </span>
      </span>
    </button>
  )
}
